import type { ApiClient } from '../client'
import type { Capabilities } from '../types'

/** src/modules/internal/capabilities.controller.ts */
export function capabilitiesEndpoints(api: ApiClient) {
  return {
    read: () => api.get<Capabilities>('capabilities'),
  }
}
